import { Component } from '@angular/core';
import { SidebarService } from '../../../../../shared/services/sidebar.service';
import { SharedDateService } from '../../../../../shared/services/shared-date.service';

@Component({
  selector: 'app-desktop-app',
  templateUrl: './desktop-app.component.html',
  styleUrl: './desktop-app.component.scss'
})
export class DesktopAppComponent {

  sidebarIsOpen: boolean = false;
  selectedDate: Date = new Date();

  constructor(private sidebarService: SidebarService, private sharedDateService: SharedDateService){
    this.sidebarService.sidebarStatus$.subscribe(res => {
      this.sidebarIsOpen = res;
    })
  }

  ngOnInit(): void {
    this.sharedDateService.selectedDate$.subscribe(date => {
      this.selectedDate = date;
    });
  }

}
